import script from "./dailyInventoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./dailyInventoryPage.vue?vue&type=script&setup=true&lang=js"

import "./dailyInventoryPage.vue?vue&type=style&index=0&id=ee950272&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee950272"]])

export default __exports__